import type { OpcaoUsuario } from '../catalogo-usuario.tipos'
export type ListarOpcoesUsuarioRepositorio = (
  sinal: AbortSignal,
) => Promise<readonly OpcaoUsuario[]>
export const criarCasoDeUsoListarOpcoesUsuario = (
  repositorio: ListarOpcoesUsuarioRepositorio,
): ListarOpcoesUsuarioRepositorio => async (sinal) => repositorio(sinal)
